'use client'

import * as React from 'react'
import * as TabsPrimitive from '@radix-ui/react-tabs'

import {cn} from '@/lib/utils'

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.List>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.List> & {
        className?: string
        'data-testid'?: string | undefined
    }
>(({className, 'data-testid': dataTestId, ...props}, ref) => (
    <TabsPrimitive.List
        ref={ref}
        className={cn(
            'inline-flex h-10 items-center justify-center border-b-2 border-b-gray-02',
            className
        )}
        data-testid={dataTestId || 'TabsList'}
        {...props}
    />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & {
        className?: string
        'data-testid'?: string | undefined
    }
>(({className, 'data-testid': dataTestId, ...props}, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
            'eyebrow-sm text-accent px-[0.8125rem] py-2 inline-flex items-center justify-center whitespace-nowrap ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 relative after:absolute after:top-full after:block after:w-full after:h-[0.125rem] after:bg-transparent data-[state=active]:after:bg-accent hover:after:bg-accent',
            className
        )}
        data-testid={dataTestId || 'TabsTrigger'}
        {...props}
    />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content> & {
        className?: string
        'data-testid'?: string | undefined
    }
>(({className, 'data-testid': dataTestId, ...props}, ref) => (
    <TabsPrimitive.Content
        ref={ref}
        className={cn(
            'mt-8 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            className
        )}
        data-testid={dataTestId || 'TabsContent'}
        {...props}
    />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export {Tabs, TabsList, TabsTrigger, TabsContent}
